<template>
    <div class="payment-error">
        <div class="img-cover">
            <img src="@/assets/illustrations/payment_error.png">
            <div class="light"></div>
        </div>
        <h1>Проблемы с оплатой</h1>
        <p class="issue">
            Мы не получили ваш платеж.<br>
            Попробуйте оплатить еще раз
        </p>
        <router-link :to="{}">
            <secondary_button>Оплатить еще раз</secondary_button>
        </router-link>
        <p class="care">
            Если не получится, <a href="#" target="_blank" class="linker">напишите нам ВКонтакте</a>, поможем разобраться.<br>
            <br>
            Сделайте скриншот чека, так мы быстрее решим проблему.
        </p>
        <div class="line"></div>
        <payment_info name="artemivanov29320" perk="Анти-грифер" :cost="749" :date="1582161476694"/>
    </div>
</template>

<script>
    import payment_info from '@/elements/custom/payment_info.vue'
    import secondary_button from '@/elements/secondary_button.vue'

    export default {
        name: "Payment_Error",
        components: {
            payment_info,
            secondary_button,
        }
    }
</script>

<style scoped lang="scss">
    .payment-error {
        width: 560px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;
        padding: 48px 96px;
        background-color: $bg_light;
        border-radius: 4px;


        .img-cover{
            position: relative;
            margin-bottom: 24px;
            .light{
                position: absolute;
                bottom: 5%;
                left: 25%;
                right: 25%;
                height: 80px;
                box-shadow: 0 24px 48px rgba($bg_line, 0.18);
            }
        }
        h1 {
            margin-bottom: 8px;
        }
        p {
            text-align: center;
        }
        p.issue ,p.care{
            font-size: 18px;
            line-height: 21px;
        }
        p.issue{
            margin-bottom: 16px;
        }
        p.care {
            margin-top: 32px;
        }

        .line {
            margin: 16px 0;
        }
        @include tablet{
            width: 100%;
            max-width: 520px;
            padding: 36px 48px;

            p.issue ,p.care{
                font-size: 16px;
                line-height: 21px;

                &.care{
                    max-width: 80%;
                }
            }
        }
        @include mobile{
            padding: 32px 24px;

            p.care{
                max-width: unset !important;
            }
        }
    }
</style>